/* tslint:disable */
/* eslint-disable */
/**
 * Ankieter API
 * Ankieter 6.0 - the API contract, source of truth for the backend and the frontend
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * NOT_CONFIGURED — a setting the step needs is empty; detail names it. UNREACHABLE — no answer at the address: wrong address, network, or the other side down. ISSUER_NOT_FOUND — the identity provider has no such realm. REJECTED_CREDENTIALS — the client id or secret, or the store\'s keys, were refused. SERVICE_ACCOUNT_DISABLED — the client may not get tokens for itself (service accounts off). MISSING_ROLE — the token lacks the role jAIn admits Ankieter with. TOKEN_REJECTED — jAIn does not accept a token from this identity provider. REFUSED — the other side knows who is asking and says no. NOT_AVAILABLE — jAIn does not offer this data to Ankieter yet. BUCKET_NOT_FOUND — the store has no such bucket. WRONG_REGION — the store expects another region; detail has the one it named, when it did. LINK_REFUSED — the store refused the signed link, often because it is signed for an address the store does not answer to. CONTENT_MISMATCH — the link gave back other bytes than were written. UNEXPECTED_RESPONSE — anything else; detail has what came back.
 * @export
 * @enum {string}
 */

export const CheckFailureDto = {
    NotConfigured: 'NOT_CONFIGURED',
    Unreachable: 'UNREACHABLE',
    IssuerNotFound: 'ISSUER_NOT_FOUND',
    RejectedCredentials: 'REJECTED_CREDENTIALS',
    ServiceAccountDisabled: 'SERVICE_ACCOUNT_DISABLED',
    MissingRole: 'MISSING_ROLE',
    TokenRejected: 'TOKEN_REJECTED',
    Refused: 'REFUSED',
    NotAvailable: 'NOT_AVAILABLE',
    BucketNotFound: 'BUCKET_NOT_FOUND',
    WrongRegion: 'WRONG_REGION',
    LinkRefused: 'LINK_REFUSED',
    ContentMismatch: 'CONTENT_MISMATCH',
    UnexpectedResponse: 'UNEXPECTED_RESPONSE'
} as const;

export type CheckFailureDto = typeof CheckFailureDto[keyof typeof CheckFailureDto];



